export default {
    getList: async function (params) {
        let option = {
            url: '/api/v1/inspect/',
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: this.$mock.userComprehensiveInspection.getList.default,
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    postFile: async function (params) {
        let option = {
            url: '/api/v1/inspect/',
            type: 'postFile',
            params: params,
            mock: {
                state: false,
                data: this.$mock.userComprehensiveInspection.getList.default,
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    generateReport: async function (params) {
        let option = {
            url: '/api/v1/inspect/' + params.report_id,
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: this.$mock.userComprehensiveInspection.getList.default,
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    getReport: async function(params) {
        let option = {
            url: '/api/v1/inspect/' + params.report_id,
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: "",
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    getFile: async function(params){
        let option = {
            url: params.url,
            type: 'file',
            params: params,
            mock: {
                state: false,
                data: "",
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
}